export type GroupRecord<T> = {
  groupKey: string
  values: T[]
}
export type GroupState<T> = {
  getGroupKey: (value: T) => string
  groupKeys: string[]
  groupMap: Record<string, GroupRecord<T>>
  groups: GroupRecord<T>[]
  items: T[]
}

export function createGroup<T>({
  getGroupKey
}: {
  getGroupKey: (value: T) => string
}): GroupState<T> {
  return {
    getGroupKey,
    groupKeys: [],
    groupMap: {},
    groups: [],
    items: []
  }
}

export function updateGroup<T>({
  update,
  state
}: {
  update: T[]
  state: GroupState<T>
}) {
  if (isSameArray(state.items, update)) return state
  const getGroupKey = state.getGroupKey
  const newState: GroupState<T> = {
    getGroupKey,
    groupKeys: [],
    groupMap: {},
    groups: [],
    items: update
  }
  for (let i = 0; i < update.length; i++) {
    const item = update[i]
    const itemGroupKey = getGroupKey(item)
    if (!newState.groupMap[itemGroupKey]) {
      const record: GroupRecord<T> = {
        groupKey: itemGroupKey,
        values: []
      }
      newState.groupMap[itemGroupKey] = record
      newState.groups.push(record)
      newState.groupKeys.push(itemGroupKey)
    }
    newState.groupMap[itemGroupKey].values.push(item)
  }
  if (isSameArray(newState.groupKeys, state.groupKeys)) {
    newState.groupKeys = state.groupKeys
  }
  for (let i = 0; i < newState.groupKeys.length; i++) {
    const groupKey = newState.groupKeys[i]
    const oldRecord = state.groupMap[groupKey]
    if (
      oldRecord &&
      isSameArray(oldRecord.values, newState.groupMap[groupKey].values)
    ) {
      newState.groupMap[groupKey] = oldRecord
      newState.groups[i] = oldRecord
    }
  }
  return newState
}

function isSameArray<T>(a: T[], b: T[]) {
  if (a === b) return true
  if (a.length !== b.length) return false
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return false
  }
  return true
}
